import { create } from 'zustand';
import type { ReviewTab } from '@/features/monitoring/review-modal/types';

// ---------------------------------------------------------------------------
// Review Modal store — Zustand
// ---------------------------------------------------------------------------

interface ReviewModalStore {
  selectedPaymentId: string | null;
  activeTab: ReviewTab;
  isOpen: boolean;
  open: (paymentId: string) => void;
  close: () => void;
  setActiveTab: (tab: ReviewTab) => void;
  resetTenantScopedState: () => void;
}

export const useReviewModalStore = create<ReviewModalStore>()((set) => ({
  selectedPaymentId: null,
  activeTab: 'transaction',
  isOpen: false,

  open: (paymentId) =>
    set({ selectedPaymentId: paymentId, isOpen: true, activeTab: 'transaction' }),

  close: () => set({ selectedPaymentId: null, isOpen: false, activeTab: 'transaction' }),

  setActiveTab: (tab) => set({ activeTab: tab }),

  // selectedPaymentId references a payment that exists in the previous tenant
  // only — clear on `cbs:tenant-switched`.
  resetTenantScopedState: () =>
    set({ selectedPaymentId: null, isOpen: false, activeTab: 'transaction' }),
}));
